import classnames from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import { Icon } from '../Icon';

import styles from './Key.module.scss';

export interface IKeyProps extends IBaseProps {
  /** Text displayed in the key, will be truncated after 2 characters */
  text: string | number;
  /** Defines the style variant of the key */
  variant?: 'active' | 'inactive' | 'neutral';
  /** Switches the key to display a check mark */
  complete?: boolean;
}

export const Key: React.FC<IKeyProps> = ({ className, text, variant = 'neutral', complete = false, dataTest }) => {
  const character = text.toString().trim().slice(0, 2);
  let content;

  if (complete) {
    content = <Icon icon="form-check" className={styles.icon} />;
  } else {
    content = <div className={styles.character}>{character}</div>;
  }

  return (
    <div
      className={classnames(styles.key, styles[variant], className, {
        [styles.complete]: complete
      })}
      data-test={dataTest}
    >
      {content}
    </div>
  );
};
